/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthState } from '@auth/store/auth.state';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { first, switchMap, take, tap } from 'rxjs/operators';
import { isAuthInitialized } from '../store/auth.selectors';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthGuard  {

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private store: Store<AuthState>
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(this.oauthService.hasValidAccessToken()).pipe(
      take(1),
      tap((authenticated: boolean) => {
        console.log('GUARD', authenticated);
        if (false === authenticated) {
          // not logged in so redirect to login page with the return url
          this.router.navigate(['/login']);
        }
      }),
      switchMap(authenticated => {
        if (authenticated) {
          return this.store.select(isAuthInitialized).pipe(first(Boolean));
        }

        return of(false);
      })
    );
  }
}
